import React, { Fragment } from "react";

import Content from "../components/Content";

const Home = () => (
  <Fragment>
    <Content />
  </Fragment>
);

export default Home;
